<template>
  <header>
    
    <div class="desktop">
      <div class="row">
        <div class="small-12 columns" :class="linkColumns">
          <nav class="links" :class="linkBackground">
            <router-link to="/" class="logo">
              <img src="../assets/images/ditaro_logo.png" alt="Ditaro - TechAmenity">
            </router-link>
            <a href="/#speed-test" v-smooth-scroll="{ duration: 1500 }">Speed Comparison</a>
            <a href="/#calculator" v-smooth-scroll="{ duration: 1500 }">Calculator</a>
            <router-link to="/help-center">Help Center</router-link>
          </nav>
        </div>
        <slot></slot> 
      </div>
    </div>
    
    <div class="mobile">
      <router-link to="/" class="logo">
        <img src="../assets/images/ditaro_logo.png" alt="Ditaro">
      </router-link>
      <div class="menu-button">
        <a @click.prevent="menuActive = !menuActive">
          <span class="bar"></span>
        </a>
      </div>
      <nav class="dropdown" :class="{ active: menuActive }" v-if="menuActive">
        <router-link to="/speed-test">Speed Test</router-link>
        <router-link to="/calculator">Calculator</router-link>
        <router-link to="/help-center">Help Center</router-link>
      </nav>
    </div>
    
  </header>
</template>

<script>
  export default {
    name: 'Header',
    props: ['linkColumns', 'linkBackground'],

    data () {
      return {
        menuActive: false
      }
    }
  }
</script>
